import Notification from '@rio-cloud/rio-uikit/Notification';
import { uniq } from 'es-toolkit/compat';
import moment from 'moment';

import { reportErrorToSentry } from '../../../configuration/setup/sentry';
import { useInvokeCommandMutation } from '../api/packageActivation/packageActivationApiSlice';
import type { PackageAdminCommand } from '../api/packageActivation/types';

export const useCreateBookingIntentsCommand = () => {
    const [invokeCommand] = useInvokeCommandMutation();

    return async (data: {
        vins: string[];
        startDate: string;
        country: string;
        operationNumberPrefix: string;
        packageCode: string;
    }) => {
        const errors = [];
        const localDate = moment(data.startDate).startOf('day').format('YYYY-MM-DD');

        for (const vin of uniq(data.vins)) {
            const invokeParams: PackageAdminCommand = {
                command: 'ReceiveBookingIntentCommand',
                payload: {
                    operationNumber: `${data.operationNumberPrefix}-${vin}`,
                    occurredAt: moment().toISOString(),
                    vin: vin,
                    packageCode: data.packageCode,
                    soldToPartyCountryCode: data.country,
                    processFlag: 'I',
                    invoicedAt: localDate,
                },
            };

            try {
                await invokeCommand(invokeParams).unwrap();
            } catch (e) {
                errors.push({ vin, error: e });
                reportErrorToSentry('Error creating booking intent', e);
                console.error(`Error creating booking intent for VIN ${vin}`, e);
            }
        }

        if (errors.length === 0) {
            Notification.success(`Successfully created ${data.vins.length} booking intent(s)`);
        } else {
            Notification.error(
                `Error occurred for VINs ${errors.map(e => e.vin).join(', ')}. Details: ${JSON.stringify(errors)}`,
                {
                    title: 'Error creating booking intents',
                    timeout: 999999,
                }
            );
        }
    };
};
